<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center" dense no-gutters>
      <v-col cols="4">
        <v-row dense no-gutters align="center" class="primary fill-height">
          <v-col cols="3" class="pa-5">
            <img :src="'/static/images/fof_logo.png'" alt="logo" width="100%" height="100%">
          </v-col>
          <v-col cols="9">
            <v-card class="elevation-12 fill-height rounded-0" min-width="450" flat outlined>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="username"
                    label="Логин"
                    prepend-icon="mdi-account"
                    type="text"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    label="Пароль"
                    prepend-icon="mdi-lock"
                    :append-icon="loginPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (loginPasswordVisible = !loginPasswordVisible)"
                    @keydown.enter="login()"
                    :type="loginPasswordVisible ? 'text' : 'password'"
                    required
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="card-actions">
                <v-btn outlined rounded color="primary" @click="forgotPass()" min-width="200">Забыли пароль?</v-btn>
                <v-spacer></v-spacer>
                <v-btn  rounded color="#005578" class="white--text" @click.native="login()" min-width="200" :disabled="!canLogin" >Войти</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1">
        &nbsp;
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AUTH_REQUEST, AUTH_LOGOUT } from '@/store/actions/auth'
import { UI_INIT_APPLICATION, UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      loginPasswordVisible: false
    }
  },
  computed: {
    canLogin: {
      get: function () {
        return this.username && this.password
      }
    }
  },
  methods: {
    forgotPass () {
      this.$router.push('/passreminder')
    },
    login: function () {
      const { username, password } = this
      this.$store.dispatch(AUTH_REQUEST, { username, password })
        .then((data) => {
          if (data.error === 'ok') {
            this.$store.dispatch(UI_INIT_APPLICATION)
              .then((initData) => {
                console.log('Application initialization complete', initData)
                this.$router.push(this.$store.getters.getDefaultPath)
              })
              .catch((err) => {
                this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка инициализации приложения' + err })
                console.log('Ошибка инициализации приложения', err)
              })
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Неверное имя пользователя или пароль' })
            console.log('Ошибка авторизации')
          }
        })
    }
  },
  mounted () {
    if (this.$store.getters.isAuthenticated) {
      console.log('User already authenticated, redirect')
      if (!this.$store.getters.getUserModules.length) {
        this.$store.dispatch(AUTH_LOGOUT)
      }
      if (this.$store.getters.getDefaultPath !== this.$route.path) {
        this.$router.push(this.$store.getters.getDefaultPath)
      }
    }
  }
}
</script>
